import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormGroupProps,
  FormHelperText,
  FormLabel,
  Stack,
} from '@mui/material';
import IncFormHelperText from 'components/forms/inc-form-helper-text/inc-form-helper-text.component';
import { ChangeEvent } from 'react';
import { useController } from 'react-hook-form';

export type CheckboxOption = {
  label: React.ReactNode;
  id: any;
  helperText?: string;
  disabled?: boolean;
};

type CheckboxGroupProps = {
  name: string;
  label?: React.ReactNode;
  options: CheckboxOption[];
  helperText?: string;
  FormGroupProps?: FormGroupProps;
  handleAdditionalLogic?: (e: ChangeEvent, val: any) => void;
};

export const CheckboxGroupField = ({
  name,
  label,
  options,
  helperText,
  FormGroupProps = {},
  handleAdditionalLogic,
}: CheckboxGroupProps) => {
  const { field, fieldState } = useController({ name });
  const { value, onChange, ...fieldRest } = field;
  return (
    <FormControl
      component="fieldset"
      variant="standard"
      error={!!fieldState.error}
    >
      {!!label && <FormLabel component="legend">{label}</FormLabel>}
      <FormGroup {...FormGroupProps}>
        {options.map(({ id, label, helperText: optionHelperText, ...rest }) => (
          <Stack key={id}>
            <FormControlLabel
              label={label}
              control={
                <Checkbox
                  data-testid={`CheckboxGroupField.Checkbox.${id}`}
                  checked={value?.includes(id)}
                  onChange={(e, checked) => {
                    let fieldValue;
                    if (checked) fieldValue = [...value, e.target.value];
                    else
                      fieldValue = value.filter(val => val !== e.target.value);
                    onChange(fieldValue);
                    handleAdditionalLogic?.(e, fieldValue);
                  }}
                  {...fieldRest}
                />
              }
              value={id}
              {...rest}
            />
            <FormHelperText sx={{ mt: -1 }}>
              <IncFormHelperText
                helperText={optionHelperText}
                data-testid={`CheckboxGroupField.Checkbox.${id}.HelperText`}
              />
            </FormHelperText>
          </Stack>
        ))}
      </FormGroup>
      <FormHelperText>
        <IncFormHelperText error={fieldState.error} helperText={helperText} />
      </FormHelperText>
    </FormControl>
  );
};
export default CheckboxGroupField;
